export const GET_ADDRESS_BY_ID_SUCCESS = 'GET_ADDRESS_BY_ID_SUCCESS';
export const GET_ADDRESS_BY_ID_REQUEST = 'GET_ADDRESS_BY_ID_REQUEST';
export const GET_ADDRESS_BY_ID_FAILURE = 'GET_ADDRESS_BY_ID_FAILURE';
export const getAddressByIdSuccess = (payload) => ({
    type: GET_ADDRESS_BY_ID_SUCCESS,
    payload,
});
export const getAddressByIdRequest = (payload) => ({
    type: GET_ADDRESS_BY_ID_REQUEST,
    payload,
});
export const getAddressByIdFailure = (payload) => ({
    type: GET_ADDRESS_BY_ID_FAILURE,
    payload,
});
